module.exports = __webpack_public_path__ + "15d7daa88aae7f4f75e2aa58524774af.pdf";